var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDangerTriangle = function SvgDangerTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DC3545",
    clipPath: "url(#danger-triangle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.707c-.559 0-1.027.468-1.027 1.027 0 .56.468 1.028 1.027 1.028.54 0 1.028-.469 1.004-1.003a1.004 1.004 0 0 0-1.003-1.053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.013 17.35a3.51 3.51 0 0 0 .008-3.553l-6.438-11.15A3.5 3.5 0 0 0 10.503.86a3.51 3.51 0 0 0-3.079 1.784L.978 13.805a3.54 3.54 0 0 0 .012 3.573 3.52 3.52 0 0 0 3.071 1.764h12.86a3.54 3.54 0 0 0 3.092-1.793m-1.398-.807c-.357.617-.99.983-1.697.983H4.058a1.92 1.92 0 0 1-1.678-.962 1.95 1.95 0 0 1-.004-1.961L8.822 3.445c.35-.613.975-.975 1.682-.975.703 0 1.332.366 1.681.979l6.443 11.158a1.92 1.92 0 0 1-.012 1.936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.247 6.491c-.49.14-.794.584-.794 1.123.025.324.045.653.07.978l.21 3.688c.024.42.35.724.768.724.42 0 .749-.325.77-.749 0-.255 0-.489.024-.748.045-.793.095-1.587.14-2.38.024-.514.07-1.028.094-1.542 0-.185-.024-.35-.094-.514a1.03 1.03 0 0 0-1.188-.58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "danger-triangle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgDangerTriangle;